import app_2 from '@/public/features/supplies_order/Frame-117127915.webp';
import bg from '@/public/features/supplies_order/Main.webp';

const intro = {
  tag: '',
  description: `Enhance your business operations by efficiently managing your supply orders right from the project. Keep track of your distributors, monitor supply availability, and ensure your team has everything they need to succeed.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Streamline Your Supply',
  second_title: ' Management\xa0with\xa0Our Supplies Order',
};

const blog = {
  title: 'Our Blog',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
for the latest trends and tips in service scheduling software free`,
};

const bookDemo = {
  title: `Book a Free Demo`,
  description: `Book a free demo to unlock the full potential of our software for HVAC contractors! Orcatec team is here to guide you. Fill out the form below to receive expert consultation. Don’t miss this opportunity to transform your HVAC business with Orcatec's cutting-edge solutions, specially designed for HVAC contractors!`,
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What is a Supplies Order?`,
  },
  title: `What is a Supplies Order?`,
  description: `A supplies order feature is an essential tool for project managers and field workers, allowing you to order and track supplies quickly and effectively. This ensures you always have what you need, when you need it, reducing downtime and improving productivity.`,
  item: [
    {
      title: 'Easy ordering',
      description:
        'Order missing supplies effortlessly right from the project. Our system makes it simple to identify what you need and place orders without leaving your workflow, saving time and reducing delays.',
    },
    {
      title: 'Distributor management',
      description:
        'Keep a comprehensive list of your preferred distributors. This makes reordering supplies straightforward and ensures you always know where to get the best materials for your projects.',
    },

    {
      title: 'Track supplies availability',
      description: `Mark the availability status of supplies for each project and track it in real time. Ensure you have a clear view of what’s available and what needs to be ordered to keep your projects running smoothly.`,
    },
  ],
};

export { blog, bookDemo, fullArticle2, intro };
